import moment from "moment-timezone";

export function formatDate(date, locale) {
  // TODO: revisar y mejorar horarios
  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
export function formatHourSimple(date, locale) {
  return new Date(date).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
}
export function formatHour(date, locale, isStreaming = false) {
  if (!isStreaming) {
    date = moment(date)
      .locale(locale)
      .utc();
  } else {
    date = moment(date).locale(locale);
  }
  return date.format("HH:mm");
}
export function formatLongDate(date, locale, isStreaming = false) {
  if (!isStreaming) {
    date = moment(date)
      .locale(locale)
      .utc();
  } else {
    date = moment(date).locale(locale);
  }
  const day = date.format("D");
  const month = date.format("MMMM");
  const year = date.format("YYYY");
  const day_format = [
    "st",
    "nd",
    "rd",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "st",
    "nd",
    "rd",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "st"
  ];
  return { day: day, month: month, sufix: day_format[day - 1], year: year };
}
